import { render, staticRenderFns } from "./comp_dpc-Newsletter.vue?vue&type=template&id=718ff401&scoped=true&"
import script from "./comp_dpc-Newsletter.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-Newsletter.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-Newsletter.vue?vue&type=style&index=0&id=718ff401&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ff401",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
